export const faqContent = {
    fr: {
        eyebrow: 'FAQ',
        title: 'Découvrez les réponses aux questions fréquemment posées dans notre FAQ.',
        items: [
            {
                question: 'Le prix est-il mensuel ? Vais-je être facturé à nouveau ?',
                answer: "Non, c'est un paiement unique. Nous ne facturons pas de frais mensuels et nous ne renouvelons pas automatiquement votre abonnement. Vous payez une seule fois et obtenez l'accès pour la période choisie (par exemple, un an, 15 mois ou 24 mois).",
            },
            {
                question: 'Comment recevoir mon abonnement ?',
                answer: 'Après le paiement, vous recevrez vos identifiants par e-mail sous 10 à 30 minutes. Vérifiez votre dossier spam. Si vous ne recevez rien, contactez-nous sur WhatsApp :',
                hasLink: true,
            },
            {
                question: "Comment s'abonner à IPTV ?",
                answer: "Pour vous abonner à IPTV, visitez notre site web et choisissez un abonnement adapté à vos besoins. Vous serez redirigé vers un autre site pour finaliser votre paiement. Une fois cela terminé, vous recevrez vos codes avec des instructions détaillées, étape par étape, pour l'installer sur vos appareils.",
            },
            {
                question: "Puis-je utiliser l'IPTV sur plusieurs appareils simultanément ?",
                answer: 'Oui, si vous avez un abonnement Gold, vous pouvez regarder sur plusieurs appareils simultanément.',
            },
            {
                question: 'Pourquoi suis-je redirigé vers un autre site pour finaliser mon achat ?',
                answer: "Pour des transactions sécurisées, vous êtes redirigé vers le site de notre partenaire de paiement de confiance. Une fois votre achat finalisé, vous recevrez votre code d'activation IPTV par e-mail. N'hésitez pas à nous contacter pour toute question.",
            },
            {
                question: "Ai-je besoin d'une antenne satellite pour utiliser l'IPTV ?",
                answer: "Non, vous vous connectez aux serveurs IPTV LIGUEE1 via Internet, et vous n'avez pas besoin d'une parabole ou d'un équipement satellite.",
            },
            {
                question: 'Puis-je payer mon abonnement avec PayPal ?',
                answer: "Oui, vous pouvez payer votre abonnement avec PayPal, Crypto ou d'autres méthodes de paiement spécifiques. Pour ces options de paiement, veuillez nous envoyer un message sur WhatsApp :",
                hasLink: true,
            },
            {
                question: 'Ce service IPTV fonctionne-t-il dans mon pays ?',
                answer: "L'IPTV fonctionne partout dans le monde, où que vous viviez ou vous trouviez. Tant que vous disposez d'une connexion Internet stable, vous pouvez regarder des milliers de chaînes TV.",
            },
        ],
    },
    es: {
        eyebrow: 'FAQ',
        title: 'Descubre las respuestas a las preguntas más frecuentes en nuestras FAQ.',
        items: [
            {
                question: '¿El precio es mensual? ¿Se me volverá a cobrar?',
                answer: 'No, es un pago único. No cobramos cuotas mensuales ni renovamos tu suscripción automáticamente. Pagas una sola vez y obtienes acceso durante el periodo elegido (por ejemplo, un año, 15 meses o 24 meses).',
            },
            {
                question: '¿Cómo recibo mi suscripción?',
                answer: 'Tras el pago, recibirás tus credenciales por email en un plazo de 10 a 30 minutos. Revisa tu carpeta de spam. Si no recibes nada, contáctanos por WhatsApp:',
                hasLink: true,
            },
            {
                question: '¿Cómo me suscribo a IPTV?',
                answer: 'Para suscribirte a IPTV, visita nuestro sitio web y elige la suscripción que mejor se adapte a tus necesidades. Serás redirigido a otro sitio para completar el pago. Una vez hecho esto, recibirás tus códigos con instrucciones detalladas, paso a paso, para instalarlo en tus dispositivos.',
            },
            {
                question: '¿Puedo usar el IPTV en varios dispositivos a la vez?',
                answer: 'Sí, si tienes una suscripción Gold puedes ver el contenido en varios dispositivos al mismo tiempo.',
            },
            {
                question: '¿Por qué se me redirige a otro sitio para completar mi compra?',
                answer: 'Por motivos de seguridad, se te redirige al sitio de nuestro socio de pago de confianza. Una vez finalizada tu compra, recibirás tu código de activación IPTV por email. No dudes en contactarnos ante cualquier duda.',
            },
            {
                question: '¿Necesito una antena parabólica para usar el IPTV?',
                answer: 'No, te conectas a los servidores IPTV de LIGUEE1 a través de Internet y no necesitas ninguna antena ni equipo satelital.',
            },
            {
                question: '¿Puedo pagar mi suscripción con PayPal?',
                answer: 'Sí, puedes pagar tu suscripción con PayPal, Cripto u otros métodos de pago específicos. Para estas opciones de pago, envíanos un mensaje por WhatsApp:',
                hasLink: true,
            },
            {
                question: '¿Este servicio IPTV funciona en mi país?',
                answer: 'El IPTV funciona en cualquier parte del mundo, vivas donde vivas. Mientras dispongas de una conexión a Internet estable, podrás ver miles de canales de TV.',
            },
        ],
    },
};
